import * as yup from 'yup';
import { i18n } from '@shared/i18n';
import GenericField from '@shared/fields/generic-field';

const regexPhoneNumber = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

yup.addMethod(yup.string, 'phone', function (message) {
  return this.test('phone', message, value => regexPhoneNumber.test(value));
});

export default class PhoneField extends GenericField {
  constructor(name, label, { required = false, validateOnChange = false } = {}) {
    super(name, label);
    this.required = required;
    this.validateOnChange = validateOnChange;
  }

  forPresenter(value) {
    return value && value.prefix && value.number
      ? `${value.prefix} ${value.number}`
      : null;
  }

  forFormCast(value) {
    return value;
  }
  
  forFormInitialValue(value) {
    return value;
  }

  forFilterInitialValue() {
    return undefined;
  }

  forFilterRules() {
    return undefined;
  }

  forFilterCast() {
    return undefined;
  }

  forFormRules() {
    const requiredMessage = i18n('validation.mixed.required').replace('${path}', this.label);
    const prefixRequiredMessage = i18n('validation.mixed.required').replace('${path}', i18n('entities.phone.fields.prefix'));
    const numberRequiredMessage = i18n('validation.mixed.required').replace('${path}', i18n('entities.phone.fields.number'));
    const invalidPhoneMessage = i18n('validation.mixed.default').replace('${path}', this.label);

    const phoneSchemaValidator = yup
      .object().shape({
        prefix: yup
          .string()
          .typeError(prefixRequiredMessage)
          .required(prefixRequiredMessage),
        number: yup
          .string()
          .typeError(numberRequiredMessage)
          .required(numberRequiredMessage),
      })

    const phoneValidator = yup
      .string(i18n('entities.phone.fields.phone'))
      .phone(invalidPhoneMessage);

    const output = [{
      validator: (rule, value, callback) => {
        try {
          if (!value) return callback();
          phoneSchemaValidator.validateSync(value);
          phoneValidator.validateSync(`${value.prefix}${value.number}`);
          callback();
        } catch (error) {
          callback(error);
        }
      },
      trigger: this.validateOnChange ? 'change' : 'blur',
    }];
    
    if (this.required) {
      output.push({
        required: !!this.required,
        message: requiredMessage,
        trigger: this.validateOnChange ? 'change' : 'blur',
      });
    }

    return output;
  }
}
